import React from "react";
import {
  Modal,
  Box,
  Typography,
  useTheme,
  Fade,
  IconButton
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "../../../../components/icons/close";

type Props = {
  children: React.ReactNode;
  title?: string | JSX.Element;
  description?: React.ReactNode | string;
  open: boolean;
  enableClose?: boolean;
  autoHeight?: boolean;
  onClose?: () => void;
};

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    backdropFilter: `blur(20px)`,
    backgroundColor: `rgba(0, 0, 0, 0.4)`
  },
  description: {
    "& a": {
      color: theme.palette.primary.main,
      fontSize: "inherit"
    },
    "& strong": {
      color: theme.palette.text.primary,
      fontSize: "inherit"
    }
  }
}));

export default function UserModal({
  children,
  title,
  description,
  open,
  enableClose,
  onClose,
  autoHeight,
  ...props
}: Props) {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      hideBackdrop
      {...props}
    >
      <Fade in={open} style={{ outline: 0 }}>
        <Box
          position="relative"
          display="flex"
          flexDirection="column"
          bgcolor="grey.200"
          borderRadius="8px"
          padding={{ xs: 3, sm: 6 }}
          justifyContent="space-between"
          maxWidth={theme.breakpoints.values.sm}
          minHeight={autoHeight ? "auto" : "300px"}
        >
          {enableClose && (
            <IconButton
              color="secondary"
              onClick={onClose}
              aria-label="close"
              style={{
                position: "absolute",
                top: theme.spacing(0.5),
                right: theme.spacing(0.5)
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          <Box
            textAlign="center"
            pt={{
              xs: enableClose ? 3 : 0,
              sm: 0
            }}
          >
            {title && (
              <Box marginBottom={4}>
                <Typography variant="h5">{title}</Typography>
              </Box>
            )}
            {description && (
              <Typography
                component="div"
                classes={{
                  root: classes.description
                }}
              >
                {description}
              </Typography>
            )}
          </Box>
          <Box>{children}</Box>
        </Box>
      </Fade>
    </Modal>
  );
}
